/* RESPONSIVE VIDEO*/
var $video = $(".responsiveVideo > video"),
  $window = $(".wrapper.wrapperMobileFix");

$(window)
  .resize(function () {
    var height = $window.height();
    $video.css({
      height: height,
    });

    var videoWidth = $video.width(),
      windowWidth = $window.width(),
      marginLeftAdjust = (windowWidth - videoWidth) / 2;

    $video.css({
      height: height,
      marginLeft: marginLeftAdjust,
      "max-width": "90%",
    });
  })
  .resize();
/* END RESPONSIVE VIDEO*/

$(function () {
  //console.log("on load in product");
});

// Call & init
$(document).ready(function () {
  //sync quickshop forms

  /* ACCOUNT FUNCTIONS */

  $(".myInfoLink").on("click", function () {
    console.log("onclick myInfoLink");

    if (!$("#orderHistory").hasClass("hide")) {
      $("#orderHistory").addClass("hide");
    }
    if ($("#myInfo").hasClass("hide")) {
      $("#myInfo").removeClass("hide");
    }
    if (!$(".myInfoLink").hasClass("chosen")) {
      $(".myInfoLink").addClass("chosen");
      $(".customerMenu a").not(".myInfoLink").removeClass("chosen");
    }
    localStorage.setItem("accountLink", "myInfo");
  });

  $(".orderHistoryLink").on("click", function () {
    console.log("onclick orderHistoryLink");

    if (!$("#myInfo").hasClass("hide")) {
      $("#myInfo").addClass("hide");
    }
    if ($("#orderHistory").hasClass("hide")) {
      $("#orderHistory").removeClass("hide");
    }
    if (!$(".orderHistoryLink").hasClass("chosen")) {
      $(".orderHistoryLink").addClass("chosen");
      $(".customerMenu a").not(".orderHistoryLink").removeClass("chosen");
    }
    localStorage.setItem("accountLink", "orderHistory");
  });

  /* END ACCOUNT FUNCTIONS */
}); /* END $(document).ready(function() */

// Update sliders on resize.
$(window).resize(function () {
  $(".ba-slider").each(function () {
    var cur = $(this);
    var width = cur.width() + "px";
    cur.find(".resize img").css("width", width);
  });
});

function drags(dragElement, resizeElement, container) {
  // Initialize the dragging event on mousedown.
  dragElement
    .on("mousedown touchstart", function (e) {
      dragElement.addClass("dragSlider");
      resizeElement.addClass("resizable");

      // Check if it's a mouse or touch event and pass along the correct value
      var startX = e.pageX ? e.pageX : e.originalEvent.touches[0].pageX;

      // Get the initial position
      var dragWidth = dragElement.outerWidth(),
        posX = dragElement.offset().left + dragWidth - startX,
        containerOffset = container.offset().left,
        containerWidth = container.outerWidth();

      // Set limits
      minLeft = containerOffset + 10;
      maxLeft = containerOffset + containerWidth - dragWidth - 10;

      // Calculate the dragging distance on mousemove.
      dragElement
        .parents()
        .on("mousemove touchmove", function (e) {
          // Check if it's a mouse or touch event and pass along the correct value
          var moveX = e.pageX ? e.pageX : e.originalEvent.touches[0].pageX;

          leftValue = moveX + posX - dragWidth;

          // Prevent going off limits
          if (leftValue < minLeft) {
            leftValue = minLeft;
          } else if (leftValue > maxLeft) {
            leftValue = maxLeft;
          }

          // Translate the handle's left value to masked divs width.
          widthValue =
            ((leftValue + dragWidth / 2 - containerOffset) * 100) /
            containerWidth +
            "%";

          // Set the new values for the slider and the handle.
          // Bind mouseup events to stop dragging.
          $(".dragSlider")
            .css("left", widthValue)
            .on("mouseup touchend touchcancel", function () {
              $(this).removeClass("dragSlider");
              resizeElement.removeClass("resizable");
            });
          $(".resizable").css("width", widthValue); //DIFFERENT
        })
        .on("mouseup touchend touchcancel", function () {
          dragElement.removeClass("dragSlider");
          resizeElement.removeClass("resizable");
        });
      e.preventDefault();
    })
    .on("mouseup touchend touchcancel", function (e) {
      dragElement.removeClass("dragSlider");
      resizeElement.removeClass("resizable");
    });
}

function closeHeader() {
  var oldTop = $(".top-nav-promo.small-down--hide").css("margin-top");
  console.log("top nav margin-top: " + oldTop);
  var oldMain = $(".main-content").css("margin-top");
  console.log("main nav margin-top: " + oldTop);
  var marginTop =
    $(".main-content")
      .css("margin-top")
      .replace(/[^-\d\.]/g, "") - 48;
  console.log("main header margin-top: " + oldMain);

  var adjustTop = marginTop + "px";
  console.log("adjustTop: " + adjustTop);

  var $el = $(".top-nav-promo.small-down--hide");
  var bottom = $el.position().top + $el.offset().top + $el.outerHeight(true);
  //console.log('bottom: ' + bottom);
  //var top = $("#search-container.activated").css("top");
  //console.log('top: ' + top);
  if ($(".site-nav--mobile").is(":visible")) {
    var adjustSearch = 96 - bottom + "px";
  } else {
    var adjustSearch = 93 - bottom + "px";
  }
  console.log("new margin-top: " + adjustSearch);
  //$('#search-container.activated').css("top",adjustSearch);

  /* timer to the top banner  */
  var now = new Date();
  var time = now.getTime();
  time += 3600 * 1000;
  now.setTime(time);
  document.cookie =
    "username=noPromo; expires=" + now.toUTCString() + "; path=/";
  //console.log('document.cookie: ' + document.cookie);
  /* END timer to the top banner  */

  /* set localStorage */
  localStorage.setItem("noPromo", "noPromo");
  /* END set localStorage */

  $(".top-nav-promo.small-down--hide").css("display", "none");
  $(".main-content").css("margin-top", adjustSearch);
  //$('.main-content').css({'padding-top' : '0px', 'margin-top' : adjustSearch });
  //$('.main-content').css("margin-top","64px");
  //$('.stickyBlogNav').css("margin-top","62px");
}


